

































































































import AppSelect from "@/components/global/ApplicationSelect.vue";
import {
  PriceOptimizerState,
  PriceOptimizerUnit
} from "@/models";
import FacilityRateQueueTable from "@/views/rate-queue/components/UnitTypesTable.vue";
import { priceOptimizerStateList } from "@/helpers/price-optimizer/price-optimizer-state-list";
import priceOptimizerModule from "@/store/modules/price-optimizer";
import SnackbarModule from "@/store/modules/snackbar";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import { AuthState } from "@storage360/login/src/interfaces/auth-state";

const priceOptimizer = namespace(priceOptimizerModule.name);
const snackbar = namespace(SnackbarModule.name);

@Component({
  name: "RateQueueSearch",
  components: { AppSelect, FacilityRateQueueTable }
})

export default class RateQueueSearch extends Vue {
  // ===== Store ===== //
  @State("auth") private auth!: AuthState;
  @State("priceOptimizer") private priceOptimizer!: PriceOptimizerState;
  @priceOptimizer.Action("getLocationCodes") public getLocationCodes!: () => void;
  @priceOptimizer.Action("getStates") public getStates!: () => void;
  @priceOptimizer.Action("getCities") public getCities!: () => void;
  @priceOptimizer.Action("getFilteredRateQueues") public getFilteredRateQueues!: (arg: PriceOptimizerUnit[]) => void;
  @snackbar.Action("errorMessage") public errorMessage!: (message: string) => void;

  // ===== Data ===== //
  public selectedLocationCode: string[] = []
  public selectedStates: string[] = []
  public selectedStateCodes: string[] = []
  public selectedCities: string[] = []

  // ===== Methods ===== //
  public handleApplyFilters(): void {
    const tempRateQueue: PriceOptimizerUnit[] = this.priceOptimizer.units.filter((filteringRateQueue: any) => {
      const changeData = filteringRateQueue.price_change_data;
      return (changeData && changeData.price_change_set && changeData.status.name !== "complete");
    });

    const filteredRateQueue: PriceOptimizerUnit[] = tempRateQueue.reduce((result: PriceOptimizerUnit[], item: PriceOptimizerUnit) => {
      let pushItem = true;

      if (this.selectedLocationCode.length > 0 && this.selectedLocationCode.indexOf(item.location_code) < 0) {
        pushItem = false;
      }

      if (this.selectedCities.length > 0 && this.selectedCities.indexOf(item.city) < 0) {
        pushItem = false;
      }

      if (this.selectedStateCodes.length > 0 && this.selectedStateCodes.indexOf(item.state) < 0) {
        pushItem = false;
      }

      if (pushItem) {
        result.push(item);
      }
      return result;
    }, []);

    this.getFilteredRateQueues(filteredRateQueue);
  }

  public handleResetFilters(): void {
    this.selectedLocationCode = [];
    this.selectedStates = [];
    this.selectedStateCodes = [];
    this.selectedCities = [];
    const tempRateQueue = this.priceOptimizer.units;
    const filteredRateQueue: PriceOptimizerUnit[] = tempRateQueue.filter((filteringRateQueue: any) => {
      const changeData = filteringRateQueue.price_change_data;
      return (changeData && changeData.price_change_set && changeData.status.name !== "complete");
    });
    this.getFilteredRateQueues(filteredRateQueue);
  }

  public handleLocationCodeChange(locationCodes: string[]): void {
    this.selectedLocationCode = locationCodes;
  }

  public handleStateChange(states: string[]): void {
    this.selectedStateCodes = [];
    priceOptimizerStateList.forEach((state) => {
      if (states.indexOf(state.state) >= 0) {
        this.selectedStateCodes.push(state.alphaCode);
      }
    });
  }

  public handleCityChange(cities: string[]): void {
    this.selectedCities = cities;
  }

  // ===== Watch ===== //
  @Watch("priceOpCurrentSelectedFilters")
  get showSkeleton(): boolean {
    const loadState = this.priceOptimizer.loadingState;
    if (this.priceOptimizer.locationCodes) {
      return loadState.includes("getting search filters");
    }
    return false;
  }

  get locationCodes(): boolean {
    return !!(this.priceOptimizer.locationCodes && this.priceOptimizer.locationCodes.length);
  }

  // ===== Lifecycle Hooks ===== //
  private created(): void {
    //
  }

  private mounted(): void {
    this.getLocationCodes();
    this.getStates();
    this.getCities();
  }
}
